<template>
<div class="vliveCover">
    <div class="upload-image">
        <div class="upload cover-image" @click="openLocalGallery">
            <div class="avatar-uploader">
                <div class="el-upload el-upload--text">
                    <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!banner.coverPicture.furl"></i>
                    <img :src="banner.coverPicture.furl + '?' + timestamp" alt="" class="avatar" v-if="banner.coverPicture.furl">
                </div>
            </div>
        </div>
        <div class="el-upload__tip">
            <el-button type="warning" class="btn" @click="openSystemGallery">素材库</el-button>
            <div>建议像素：1280（宽）*720（高），JPG、PNG格式，大小不超过5M。 </div>
        </div>
    </div>
    <!--<div class="cover-list">-->
        <!--<div class="cover-image" v-for="(banner, index) in vliveModel.bannerList" :key="index">-->
            <!--<div class="del"><i class="icon icon_garbage" @click="delImage(index)"></i></div>-->
            <!--<img :src="banner" alt="">-->
        <!--</div>-->
    <!--</div>-->
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="editImage" :uploadType="uploadType"></localCropper>
    <systemCropper :cropperOption="cropperOption" ref="systemCropper" @setImage="editImage"  :uploadType="uploadType"></systemCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import SystemCropper from 'base/cropper/systemCropper'
import {mapGetters, mapActions} from 'vuex'
import {editVliveCover} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
export default {
    name: 'vliveCover',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            cropperOption: {
                fixedNumber: [1280, 720], // 截图框的宽高比例
                enlarge: 4, // 图片根据截图框输出比例倍数
                autoCropWidth: 320, // 默认生成截图框宽度
                autoCropHeight: 180 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: 120,
                height: 120
            },
            banner: {
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            }
        }
    },
    mounted() {
    },
    methods: {
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        openSystemGallery() {
            this.$refs.systemCropper.openDialog()
        },
        editImage (file) {
            this.timestamp = new Date().getTime()
            editVliveCover({
                data:
                    {
                        innerid: this.vliveModel.assetinnerid,
                        coverPicture: formatFileInfo(file)
                    },
                success: data => {
                    this.$message.success('修改成功')
                    this.banner.coverPicture = file
                    this.setLoading(false)
                    this.setVliveModelBanner(Object.assign({}, this.banner))
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelBanner',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                if (this.vliveModel.banner.coverPicture && this.vliveModel.banner.coverPicture.furl) {
                    this.banner = Object.assign({}, this.vliveModel.banner)
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'loading'
        ])
    },
    components: {
        LocalCropper,
        SystemCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveCover {
    .upload-image{
        @include flexBox(flex-start);
        .cover-image{
            margin-right: 30px;
            .avatar-uploader {
                box-sizing: border-box;
                width: 320px;
                height: 180px;
            }
        }
        .el-upload__tip{
            color: $tcolor-grey;
            .btn{
                margin-bottom: 10px;
            }
            div{
                margin-bottom: 5px;
            }
        }
    }
    .cover-list{
        @include flexBox(flex-start);
       flex-wrap: wrap;
        width: 1020px;
        margin-top: 30px;
        img{
            width: 320px;
            height: 180px;
        }
        .cover-image{
            position: relative;
            margin-right: 20px;
            margin-bottom: 20px;
            .del{
                display: none;
                background: rgba(0, 0, 0, 0.3);
                position: absolute;
                top:0;
                right: 0;
                bottom:0;
                left:0;
                .icon{
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                }
            }
            &:hover{
                .del{
                    @include flexBox(center);
                }
            }
        }
    }
}
</style>
